import { Box } from '@mui/material';
import { ScrollLayoutProps } from './ScrollLayout.props';

export const ScrollLayout = ({
  children,
  direction,
  maxHeight,
  maxWidth,
  hideScrollbars,
  smooth,
  fullHeight,
  fullWidth,
  sx,
  ...props
}: ScrollLayoutProps) => {
  const getScrollStyles = () => {
    const styles: any = {};

    // Set overflow based on direction (default to 'vertical' if not specified)
    const scrollDirection = direction || 'vertical';

    if (scrollDirection === 'vertical') {
      styles.overflowY = 'auto';
      styles.overflowX = 'hidden';
    } else if (scrollDirection === 'horizontal') {
      styles.overflowX = 'auto';
      styles.overflowY = 'hidden';
    } else if (scrollDirection === 'both') {
      styles.overflow = 'auto';
    }

    // Set dimensions
    if (maxHeight) styles.maxHeight = maxHeight;
    if (maxWidth) styles.maxWidth = maxWidth;
    if (fullHeight) styles.height = '100%';
    if (fullWidth) styles.width = '100%';

    // Hide scrollbars
    if (hideScrollbars) {
      styles.scrollbarWidth = 'none'; // Firefox
      styles.msOverflowStyle = 'none'; // IE and Edge
      styles['&::-webkit-scrollbar'] = { display: 'none' }; // Chrome, Safari, Opera
    }

    // Smooth scrolling
    if (smooth) {
      styles.scrollBehavior = 'smooth';
    }

    return styles;
  };

  return (
    <Box
      sx={{
        ...getScrollStyles(),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
